module.exports = __webpack_public_path__ + "static/media/react_developer.aefa0890.jpg";